import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

const NativeStartupRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if we're running in a Capacitor native environment
    const isNative = Capacitor?.isNativePlatform?.() ||
                     window.location.protocol === 'capacitor:' ||
                     (window.location.hostname === 'localhost' && /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent));
    
    // Prevent redirect loops
    const hasRedirected = sessionStorage.getItem('nativeRedirected');
    
    // Landing page routes that should redirect to app in native
    const landingRoutes = ['/', '/index.html', '/landing', '/landing-v2', '/landing-v3', '/landing-v4', '/landing-v5', '/landing-page'];
    
    if (isNative && landingRoutes.includes(location.pathname) && !hasRedirected) {
      sessionStorage.setItem('nativeRedirected', 'true');
      navigate('/app', { replace: true });
    }
  }, [location.pathname, navigate]);

  return null; // This component doesn't render anything
};

export default NativeStartupRedirect;